// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1Ii4p","alert":"SettungsInbox_alert__cNvZQ"};